import type { EntryPointRef } from '@atlassian/entry-point-types/types';
import { browseAgentEntryPoint } from '@atlassian/studio-browse-kit/browse-agent-entrypoint';
import { loadEntryPoint } from 'react-relay';

import { getAggRelayEnvironment } from '@townsquare/relay-utils/agg-environment';
import { createResource } from '@townsquare/router/resources/createResource';
import type { RouteResource } from '@townsquare/router/routing-types';
import type { ResourceContext } from '@townsquare/router/types';
import { fg } from '@townsquare/stat-sig/gate';

type TeamsBrowseAgentEntryPointReference = EntryPointRef<typeof browseAgentEntryPoint>;

const getEntryPointParams = (resourceContext: unknown) => {
	const context = resourceContext as ResourceContext;

	return {
		cloudId: context.collabContext?.rovoWorkspace,
		product: fg('townsquare_enable_rovo_ubp_header') ? 'teams' : 'rovo',
	};
};

export const teamsBrowseAgentEntryPointResource: RouteResource<
	TeamsBrowseAgentEntryPointReference | undefined
> = createResource<TeamsBrowseAgentEntryPointReference | undefined>({
	type: 'TEAMS_BROWSE_AGENT_ENTRY_POINT',
	getKey: (_routerContext, resourceContext) => {
		const { cloudId, product } = getEntryPointParams(resourceContext);
		return `teams-browse-agent-entry-point-${cloudId ?? 'unavailable'}-${product}`;
	},
	getData: async (_routerContext, resourceContext) => {
		const { cloudId, product } = getEntryPointParams(resourceContext);

		if (!cloudId) {
			return;
		}

		return loadEntryPoint({ getEnvironment: getAggRelayEnvironment }, browseAgentEntryPoint, {
			cloudId,
			product,
		});
	},
});
